import { combineReducers } from "redux";

import productsList from "./productReducer";
import productCompareReducer from "./productCompareReducer";
import productDetailReducer from "./productDetailReducer";
import cartReducer from "./cartReducer";
import geoLocationReducer from "./geoLocationReducer";
import home from "./homeReducer";
import navigationReducer from "./navigationReducer";
import navReducer from "./navReducer";
import displayHideFooterReducer from "./footerReducer";
import termsAndConditionsReducer from "./termsAndConditionsReducer";
import SliceBreadcrumb from "./breadcrumbReducer";
import alertSelect from "./AlertReducer";
import checkoutReducer from "./checkoutReducer";
import creditCheckReducer from "./creditCheckReducer";
import userProfileSync from "./userProfileReducer";
import upgradeReducer from "./upgradeReducer";
import checkoutPageErrorReducer from "./checkoutErrorReducer";
import getHelpReducer from "./getHelpReducer";
import dealDetailsReducer from "./dealDetailsReducer";
import dealBuilderReducer from "./dealBuilderReducer";
import commonReducer from "./commonReducer";
import pageBuilderReducer from "./pageBuilderReducer";

// COMBINED REDUCERS
const reducers = {
  productCompare: productCompareReducer,
  productSearchList: productsList.productSearchList,
  productDetails: productDetailReducer,
  cartDetails: cartReducer,
  geoLocation: geoLocationReducer,
  home,
  navigation: navigationReducer,
  navDetails: navReducer,
  displayHideFooter: displayHideFooterReducer,
  termsAndConditions: termsAndConditionsReducer,
  SliceBreadcrumb: SliceBreadcrumb,
  alertSelect: alertSelect,
  checkoutDetails: checkoutReducer,
  upgrade: upgradeReducer,
  creditCheckDetails: creditCheckReducer,
  userProfileSync: userProfileSync,
  checkoutPageError: checkoutPageErrorReducer,
  getHelp: getHelpReducer,
  dealDetails: dealDetailsReducer,
  common: commonReducer,
  pageBuilder: pageBuilderReducer,
  dealBuilder: dealBuilderReducer,
  //hide from sessionstorage
};

export default combineReducers(reducers);
